export const common = {
  namespaced: true,
  state: {
    messages: {}
  },
  actions: {
    setFlashMessage(context: any, messages: any): void {
      context.commit('SET_FLASH_MESSAGE', messages)
    },
  },
  mutations: {
    SET_FLASH_MESSAGE(state: any, messages: any) {
      state.messages = messages
    },
  },
  getters: {
    fullThumbImageUrl() {
      return (filename) => {
        if (!filename) {
          return ''
        }

        const fileParts = filename.split('.')
        fileParts[fileParts.length - 1] = 'jpg'
        fileParts[fileParts.length - 2] += '-thumb'

        return fileParts.join('.')
      }
    }
  }
}
